// import ifrsImg from '../../images/services/ifrs.jpg';
import { subTopicImages } from "../servicesData";
import ServiceDetailPage from "../ServiceDetailPage";

const IFRSIndASCompliance = () => {
  const serviceData = {
    title: "IFRS / Ind-AS Accounting Support",
    heading: "IFRS / Ind-AS Accounting Support",
    image: subTopicImages["IFRS / Ind-AS Accounting Support"],
    intro:
      "Companies operating in India and globally must increasingly comply with Ind-AS and IFRS reporting frameworks.",
    description: [
      "We provide specialist support for technical accounting and financial reporting conversions.",
    ],
    services: [
      {
        title: "IFRS / Ind-AS Accounting Services",
        text: "Our assistance includes:",
        list: [
          "GAAP conversion impact assessment",
          "implementation guidance and advisory",
          "assistance with preparation of compliant financial statements",
          "disclosure framework and note preparation",
          "training and support for finance teams",
        ],
        extraInfo:
          "Our experts ensure that your reporting remains technically sound, globally compliant and aligned with investor expectations.",
      },
    ],
    benefitsIntro: "This service is particularly relevant for:",
    benefits: [
      "multinational subsidiaries",
      "listed-ready organisations",
      "investor-backed companies",
    ],
    research: "",
  };

  return (
    <ServiceDetailPage
      {...serviceData}
      overview={serviceData.description}
      services={serviceData.services}
      projects={serviceData.benefits}
    />
  );
};

export default IFRSIndASCompliance;
